var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"shape shape-1"}),_c('div',{staticClass:"shape shape-2"}),_c('div',{staticClass:"shape shape-3"}),_c('div',{staticClass:"shape shape-4"})])])
}]

export { render, staticRenderFns }